module.exports = __webpack_public_path__ + "static/media/month_12.a92a8616.png";